/**
 * CRPD-7287 (I06) — ordering contract for "populate missing variables → accept → done".
 *
 * Jennifer: "there is a flash of the list of the scenarios, before the new scenario is added,
 * after the 'populate missing variables' modal closes. The desired is: populate missing
 * variables → accept → risk assessment view, with scenarios in the risk register."
 *
 * The flash happened because the review modal was dismissed FIRST, re-revealing the picker
 * underneath while the add + refetch were still in flight. The review must stay on screen
 * until the commit resolves, and must stay on screen (not dismissed) if the commit throws, so
 * the user can retry rather than losing their selection.
 */
export const commitAfterReview = async ({
  save,
  commit,
  closeReview,
  onError,
  setSaving,
}: {
  /** Persist the reviewed variable values. Omitted by the Skip path. */
  save?: () => Promise<void>;
  /** Add the selected items; typically also refetches and closes the parent modal. */
  commit: () => Promise<void>;
  /** Dismiss the review modal — only ever after a successful commit. */
  closeReview: () => void;
  onError: (error: unknown) => void;
  setSaving: (saving: boolean) => void;
}): Promise<void> => {
  setSaving(true);
  try {
    if (save) await save();
    await commit();
    closeReview();
  } catch (error) {
    onError(error);
  } finally {
    setSaving(false);
  }
};
